import { getAddressInfo, getDefaultAddress } from '@/api/address'

/**
 * 获取默认地址
 */
export const getDefaultAddr = async () => {
  const result = await getDefaultAddress()
  const addressInfo = result.data.data.addressInfo
  
  if (Object.keys(addressInfo).length !== 0) {
    return {
      status: true,
      addressInfo
    }
  }
  
  return {
    status: false,
    addressInfo: {}
  }
}

/**
 * 根据 ID 获取地址详情
 */
export const getAddress = async (addressId) => {
  const result = await getAddressInfo({ address_id: addressId })
  const data = result.data.data
  
  return {
    status: data.status,
    addressInfo: data.addressInfo
  }
}

/**
 * 获取当前地址（优先使用选中地址，否则使用默认地址）
 */
export const getCurrentAddress = async ({ state, commit }) => {
  const address = state.addressId 
    ? await getAddress(state.addressId)
    : await getDefaultAddr()

  if (address.status) {
    commit('setAddressInfo', address.addressInfo)
  }
  
  return address
}
